export * as Api from './api';

export enum AdminUserRealm {
  Super = 'SUPER',
  Eis = 'EIS',
  Lp = 'LP',
}

export enum DirtyAuthCacheChangeType {
  RoleChange = 'role_change',
  OrgRemoval = 'org_removal',
}
